import React from "react";
import styled from "styled-components";
import { ExperienceData } from "./ExperienceData";

function Experience() {
  return (
    <Container>
      <section className="experience">
        <h1 className="main-container experience-title" id="experience">
          Experience
        </h1>

        <div className="main-container">
          <div className="experience-container-item">
            {ExperienceData.map((item, index) => (
              <div
                className={`timeline-block timeline-block-${item.experiencePosition}`}
                key={index}
              >
                <div
                  className="marker"
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background: `${item.markerColor}`,
                    marginTop: "10px",
                    zIndex: "1",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "25px",
                    color: "var(--color-light)",
                    boxShadow:
                      "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                  }}
                >
                  {item.markerIcon}
                </div>

                <div className="timeline-content">
                  <h3>{item.experienceTitle}</h3>
                  <div className="timeline-meta">{item.experienceSubTitle}</div>
                  {Array.isArray(item.experienceDesc) ? (
                    item.experienceDesc.map((para, i) => (
                      <p className="timeline-desc" key={i}>
                        ● {para}
                      </p>
                    ))
                  ) : (
                    <p className="timeline-desc">{item.experienceDesc}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Experience;

const Container = styled.div`
  section.experience {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(233, 224, 212, 1) 100%,
      rgba(255, 255, 255, 1) 100%
    );
  }

  .experience-title {
    margin-bottom: 20px;
  }

  .experience-container-item {
    width: 100%;
    padding: 20px 0;
    margin: 50px auto;
    position: relative;
    overflow: hidden;
  }

  .experience-container-item:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -1px;
    width: 5px;
    height: 100%;
    border-radius: 12px;
    background: black;
    z-index: 1;
  }

  .timeline-block {
    width: calc(50% + 8px);
    display: flex;
    justify-content: space-between;
    clear: both;
  }

  .timeline-block-right {
    float: right;
  }

  .timeline-block-left {
    float: left;
    direction: rtl;
  }

  .timeline-content {
    width: 100%;
    padding: 20px 15px;
    color: #666;
    border-radius: 7px;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 3px 0px,
      rgba(27, 31, 35, 0.3) 0px 0px 0px 2px;
  }

  .timeline-content:hover {
    background: var(--color-light);
    color: white;
  }

  .timeline-content h3 {
    margin-bottom: 5px;
    font-size: 25px;
    font-weight: bold;
    direction: ltr;
  }

  .timeline-meta {
    font-size: 0.9rem;
    color: var(--color-dark);
    opacity: 0.8;
    margin-bottom: 8px;
    font-weight: 600;
  }

  .timeline-desc {
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
    margin: 8px 0;
  }

  .timeline-content p {
    font-size: 15px;
    line-height: 1.5em;
    word-spacing: 1px;
    color: #2b2929ff;
    margin-top: 10px;
    direction: ltr;
  }

  .marker:hover {
    animation: pulse2 0.3s 2;
  }

  @keyframes pulse2 {
    0% {
      transform: scale(1);
    }
    35% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  @media screen and (max-width: 500px) {
    .experience-container-item:before {
      left: 5%;
      width: 4px;
    }

    .timeline-block {
      width: 100%;
      margin-bottom: 30px;
    }

    .main-container {
      width: 100%;
    }

    .timeline-block-right,
    .timeline-block-left {
      float: none;
      direction: ltr;
    }
  }
`;
